import {animate, inView} from 'motion';

/** Reveal footer groups once, using the shared site entry timing. */
class Footer extends HTMLElement {
    connectedCallback() {
        this.abort = new AbortController();
        this.animations = new Map();
        this.observers = [];
        this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
        const styles = getComputedStyle(this);
        const duration = parseFloat(styles.getPropertyValue('--site-entry-duration')) / 1000;
        const ease = styles.getPropertyValue('--site-entry-ease').match(/[\d.]+/g).map(Number);

        this.querySelectorAll('[data-footer-reveal]').forEach((element) => {
            this.observers.push(inView(element, () => {
                if (this.reducedMotion.matches || this.contains(document.activeElement)) return;
                this.animations.set(element, animate(element, {
                    opacity: [0, 1],
                    transform: ['translateY(24px)', 'translateY(0px)'],
                }, {duration, ease, delay: Number(element.dataset.revealDelay || 0)}));
            }, {margin: '0px 0px -24px 0px'}));
        });

        this.reducedMotion.addEventListener('change', () => {
            if (this.reducedMotion.matches) this.finishAnimations();
        }, {signal: this.abort.signal});
        // Keep links steady and visible when navigating the footer by keyboard.
        this.addEventListener('focusin', () => this.finishAnimations(), {signal: this.abort.signal});
    }

    finishAnimations() {
        this.animations.forEach((animation) => animation.complete());
    }

    disconnectedCallback() {
        this.abort.abort();
        this.observers.forEach((stop) => stop());
        this.animations.forEach((animation) => animation.stop());
    }
}

customElements.define('fk-footer', Footer);
